<template>
    <div>
        <menu-bar></menu-bar>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">
                <ol class="breadcrumb noprint">
                    <li>
                        <a href="#/">
                            <i class="fa fa-home" aria-hidden="true"></i> INICIAL
                        </a>
                    </li>
                    <li class="active">
                        <i class="fa fa-suitcase" aria-hidden="true"></i> PACPON COM POSSÍVEIS PROBLEMA DE SINAL
                    </li>
                </ol>
                <div class="row">

                    <div class="col-md-3 noprint">
                        <button class="btn-danger btn noprint" type="button" @click="print()" style="margin-top: 3px">
                            <i class="fa fa-print" aria-hidden="true"></i> IMPRIMIR
                        </button>
                    </div>

                    <div class="col-md-9 noprint">
                        <blockquote class="blockquote-reverse">
                            Total de pacpon com problema: <b>{{ contratos.length }}</b>
                        </blockquote>
                    </div>

                </div>
                <div class="row">

                    <div class="col-md-12" >

                        <table id="mytable" class="table table-bordred ">

                            <thead>
                                <tr>
                                    <th>NOME</th>
                                    <th style="text-align: center;width: 140px">TEMPERATURA</th>
                                    <th style="text-align: center;width: 140px">RX POWER</th>
                                    <th style="text-align: center;width: 140px">TX POWER</th>
                                    <th style="text-align: center;width: 140px" class="noprint">AÇÕES</th>
                                </tr>
                            </thead>

                            <tbody>

                                <tr class="notice" v-for="r in contratos" v-bind:key="r._id" :class="{'notice-danger': r.status === 0, 'notice-warning': r.status === 1}">
                                    <td>
                                        <b>{{ r.nome }}</b><br/>
                                    </td>
                                    <td class="text-center">
                                        <b :class="{low: r.info.onu.temperature.status !== 'Normal'}">{{ r.info.onu.temperature.value }}</b>
                                        <br/>
                                    </td>
                                    <td class="text-center">
                                        <b :class="{low: r.info.onu.rx_power.status !== 'Normal'}">{{ r.info.onu.rx_power.value }}</b>
                                        <br/>
                                    </td>
                                    <td class="text-center">
                                        <b :class="{low: r.info.onu.tx_power.status !== 'Normal'}">{{ r.info.onu.tx_power.value }}</b><br/>
                                    </td>
                                    <td class="noprint text-center">
                                        <a :href="'#/caixa-pacpon/add/' + r._id" class="btn btn-primary btn-xs">
                                            ABRIR <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                                        </a>
                                    </td>
                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { CaixaPacPon } from "../../class/index";

export default {
    data() {
        return {
            contratos: [],
            user: null,
            interval: null,
            nome: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.loadSemVlam();
        this.interval = setInterval(() => this.buscar(), 60000);
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    methods: {
        loadSemVlam() {
            CaixaPacPon.allProblemasSinal()
                .then(rows => (this.contratos = rows.caixas))
                .catch(err => console.log(err));
        },
        print() {
            window.print();
        }
    }
};
</script>

<style scoped>
.low {
    color: RED;
}
.notice:first-child {
    margin-top: 10px;
}
.notice {
    padding: 15px;
    background-color: #fafafa;
    border-left: 6px solid #7f7f84;
    margin-bottom: 10px;
    -webkit-box-shadow: 0 5px 8px -6px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 0 5px 8px -6px rgba(0, 0, 0, 0.2);
    box-shadow: 0 5px 8px -6px rgba(0, 0, 0, 0.2);
}
.notice-sm {
    padding: 10px;
    font-size: 80%;
}
.notice-lg {
    padding: 35px;
    font-size: large;
}
.notice-success {
    border-color: #80d651;
}
.notice-success > strong {
    color: #80d651;
}
.notice-info {
    border-color: #45abcd;
}
.notice-info > strong {
    color: #45abcd;
}
.notice-warning {
    border-color: #feaf20;
}
.notice-warning > strong {
    color: #feaf20;
}
.notice-danger {
    border-color: #d73814;
}
.notice-danger > strong {
    color: #d73814;
}
.notice > .desc {
    display: none;
}
.readMore {
    cursor: pointer;
}
</style>
